export default __webpack_public_path__ + "static/media/396.0c4cc81d.gif";